import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

// Import all logos
import MajisLogo from "../Assets/Majis-Logo-White.png";
import NamaLogo2 from "../Assets/nama-logo2.png";
import VeoliaLogo from "../Assets/veolia.png";
import MarafiqLogo from "../Assets/Marafiq-Logo-White.png";
import WebsiteIcon from "../Assets/website-Icon-new.png";
import FpiLogo from "../Assets/fpi-logo.png";
import SuezLogo from "../Assets/suez-logo.png";
import GfcLogo from "../Assets/gfc-logo.png";
import HsLogo from "../Assets/ha-logo.png";
import TdLogo from "../Assets/td-logo.png";
import GsLogo from "../Assets/gs-logo.png";
import AcwuaLogo from "../Assets/acwua-logo.png";
import BwLogo from "../Assets/bw-logo.png";
import QuiLogo from "../Assets/gwi-logo.png";
import GwpLogo from "../Assets/gwp-logo.png";
import IwraLogo from "../Assets/iwra-logo.png";
import NwpLogo from "../Assets/nwp-logo.png";
import OhcLogo from "../Assets/ohc-logo.png";
import PwpLogo from "../Assets/pwp-logo.png";
import SupportedBy from "../Assets/supportedby.png";

const SponsorSection = () => {
  const { t } = useTranslation();

  const sponsorGroups = [
    {
      title: "hostedBy",
      logos: [NamaLogo2],
      singleColumn: true,
      logoStyle: { width: 120, height: 80 },
    },
    {
      title: "supportedBy",
      logos: [SupportedBy],
      singleColumn: true,
      logoStyle: { width: 200, height: 120 },
    },
    {
      title: "strategicPartners",
      logos: [MajisLogo, VeoliaLogo, MarafiqLogo],
      logoStyle: { width: 110, height: 80 },
    },
    {
      title: "SmartCitiesPartner",
      logos: [TdLogo],
      singleColumn: true,
      logoStyle: { width: 160, height: 80 },
    },
    {
      title: "PlatinumSponsors",
      logos: [FpiLogo, SuezLogo],
      logoStyle: { width: 136, height: 80 },
    },
    {
      title: "GoldSponsors",
      logos: [GfcLogo, HsLogo],
      logoStyle: { width: 136, height: 80 },
    },
    {
      title: "LanyardSponsor",
      logos: [GsLogo],
      singleColumn: true,
      logoStyle: { width: 150, height: 80 },
    },
    {
      title: "SupportingPartners",
      logos: [
        BwLogo,
        QuiLogo,
        GwpLogo,
        AcwuaLogo,
        IwraLogo,
        NwpLogo,
        OhcLogo,
        PwpLogo,
      ],
      logoStyle: { width: 120, height: 80 },
      grid: true,
    },
  ];

  const Divider = () => (
    <Box
      sx={{
        width: { xs: "120px", sm: "160px" },
        height: "2px",
        backgroundColor: "rgba(26,169,139, 1)",
        margin: "0 auto",
        mt: { xs: 4, sm: 5 },
        mb: { xs: 0, sm: 0 },
      }}
    />
  );

  return (
    <Box sx={{ textAlign: "center", mt: "auto", py: 0 }}>
      {sponsorGroups.map((group, index) => (
        <React.Fragment key={group.title}>
          <Box sx={{ my: 2 }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: "1rem",
                letterSpacing: "0.3px",
                color: "#ffffff",
                mb: 2,
                fontWeight: 400,
              }}
            >
              {t(group.title)}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                gap: { xs: 2, sm: 3 },
                ...(group.grid && {
                  maxWidth: 800,
                  margin: "0 auto",
                }),
                ...(group.singleColumn && {
                  flexDirection: "column",
                }),
              }}
            >
              {group.logos.map((logo, idx) => (
                <Box
                  key={idx}
                  sx={{
                    width: group.logoStyle.width,
                    height: group.logoStyle.height,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 1,
                  }}
                >
                  <img
                    src={logo}
                    alt={`${group.title} logo ${idx + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      filter: "brightness(0) invert(1)",
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Box>
          {index !== sponsorGroups.length - 1 && <Divider />}
        </React.Fragment>
      ))}

      {/* Website Link */}
      <Divider />
      <Box sx={{ mt: 2 }}>
        <Link
          href="http://www.omanwaterweek.com"
          target="_blank"
          rel="noopener"
          sx={{
            color: "#ffffff",
            textDecoration: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box sx={{ width: 50, height: 50 }}>
            <img
              src={WebsiteIcon}
              alt="Website"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
          <Typography
            sx={{
              fontSize: { xs: "0.9rem", sm: "1.1rem" },
              letterSpacing: "0.3px",
              color: "#ffffff",
            }}
          >
            www.omanwaterweek.com
          </Typography>
        </Link>
      </Box>
      <Divider />
    </Box>
  );
};

export default SponsorSection;
